<script setup>
import {computed, onMounted} from 'vue';

import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import HeaderBlock from "../../../auth/layouts/components/HeaderBlock.vue";
import LiveDesigner from "../../../live-designer/LiveDesigner.vue";
import AuthContactAndBrandingFooter from "../../../auth/layouts/components/AuthContactAndBrandingFooter.vue";
import HamburgerNavbar from "../../../auth/layouts/components/HamburgerNavbar.vue";
import OnboardingNav from "../../../auth/pages/Onboarding/OnboardingNav.vue";
import OnboardingContent from "../../../auth/pages/Onboarding/OnboardingContent.vue";
import {useRoute} from "vue-router";

const portalContentAndDesignStore = usePortalContentAndDesignStore();
const layout = computed(() => portalContentAndDesignStore.portalLayoutSettings.portal_layout);
const designerEnabled = computed(() => portalContentAndDesignStore.liveDesignerEnabled);

const currentRoute = useRoute();

onMounted(() => {
    if (portalContentAndDesignStore.showOnboarding &&
        !['approval','complete-invitation'].includes(currentRoute.name) &&
        currentRoute.name === 'referral-profile'
    ) {
        setOnboardingStep(2);
    }
});

const setOnboardingStep = (step) => {
    axios.post(route('partners_int.page_settings.onboarding.set-step'), {
        step: step
    }).then(response => {
        const status = parseInt(response.data.status || -1);
        if (status === 1) {
            portalContentAndDesignStore.onboardingStep = step;
            console.log('Onboarding step set successfully:', response.data.step);
        }
    }).catch(error => {
console.error('Error setting onboarding step:', error);
    });
};

</script>
<template>
    <div :class="[
            'pt-14 lg:pt-0',
            designerEnabled ? 'flex overflow-hidden h-screen' : '',
            portalContentAndDesignStore.getPortalLayoutBackgroundColor
         ]
    ">
        <div v-if="designerEnabled" class="flex">
            <LiveDesigner :auth-view="true"/>
        </div>

        <div :class="designerEnabled ? 'flex overflow-y-auto flex-col flex-1' : ''">
            <div :class="layout === 'three' ? 'flex flex-col lg:flex-row h-screen overflow-hidden' : designerEnabled ? 'h-screen overflow-hidden' : 'min-h-screen'">

                <hamburger-navbar />

                <main
                    :class="{
                        'flex-1 overflow-y-auto': layout === 'three' || designerEnabled,
                        '-mt-24': layout === 'one'
                      }"
                >
                    <div class="px-4 pb-12 mx-auto max-w-7xl sm:px-8 lg:px-12">
                        <header-block v-if="layout === 'three'" container-classes="my-8 lg:mt-14" />

                        <template v-if="portalContentAndDesignStore.showOnboarding && !['approval','complete-invitation'].includes(currentRoute.name)">
                            <onboarding-nav />
                            <onboarding-content />
                        </template>

                        <template v-else>
                            <router-view />
                        </template>

                        <auth-contact-and-branding-footer />
                    </div>
                </main>
            </div>
        </div>
    </div>
</template>
